import { PATH } from 'constants/path';
import { useRouter } from 'next/router';
import React from 'react';
import { IArticleCategorySummary } from 'types/cms';

import Container from '@material-ui/core/Container';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import styles from './style.module.scss';

interface ContentHubMenuProps {
  categories: IArticleCategorySummary[];
  selectedCategorySlug: string | null;
}

export const ContentHubMenu = ({ categories, selectedCategorySlug }: ContentHubMenuProps) => {
  const router = useRouter();

  const handleChange = (event, newValue) => {
    router.push(`${PATH.ARTICLE_CATEGORY}/${newValue}`);
  };

  return (
    <div className={styles.container}>
      <Container>
        <Tabs
          value={selectedCategorySlug ?? false}
          onChange={handleChange}
          aria-label="article category"
          variant="scrollable"
          scrollButtons="auto"
        >
          {categories.map(category => {
            return <Tab key={category.slug} label={category.name} value={category.slug} />;
          })}
        </Tabs>
      </Container>
    </div>
  );
};
